import i18n from 'services/i18n'
import { Conversation } from 'types/Api'

type ConversationMetadataArray = Conversation[]

const getSortedConversationsByDate = (conversations: ConversationMetadataArray) =>
  conversations.sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  )

const getDaysAgo = (updatedAt: number) => {
  const now = new Date()

  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  )

  const conversationDate = new Date(updatedAt * 1000)
  const conversationStartOfDay = new Date(
    conversationDate.getFullYear(),
    conversationDate.getMonth(),
    conversationDate.getDate(),
  )

  const differenceInMiliSeconds
    = startOfToday.getTime() - conversationStartOfDay.getTime()

  return Math.round(differenceInMiliSeconds / (1000 * 60 * 60 * 24))
}

export const getGroupedConversationSortedByDate = (
  conversations?: ConversationMetadataArray,
) => {
  if (!conversations) return {}

  const sortedConversations = getSortedConversationsByDate(conversations)

  return sortedConversations.reduce<Record<string, ConversationMetadataArray>>(
    (acc, conversation) => {
      let group: string

      const daysAgo = getDaysAgo(conversation.updatedAt)

      if (daysAgo === 0) {
        group = i18n.t('conversation_history.today')
      }
      else if (daysAgo === 1) {
        group = i18n.t('conversation_history.yesterday')
      }
      else if (daysAgo <= 7) {
        group = i18n.t('conversation_history.latest_7_days')
      }
      else if (daysAgo <= 15) {
        group = i18n.t('conversation_history.latest_15_days')
      }
      else if (daysAgo <= 30) {
        group = i18n.t('conversation_history.latest_30_days')
      }
      else if (daysAgo <= 60) {
        group = i18n.t('conversation_history.latest_60_days')
      }
      else {
        group = i18n.t('conversation_history.more_than_60_days')
      }

      acc[group] = [...(acc[group] || []), conversation]
      return acc
    },
    {},
  )
}

export const getConversationsSortedByDate = (
  conversations?: ConversationMetadataArray,
) => {
  if (!conversations) return []

  return getSortedConversationsByDate(conversations)
}
